module.exports = __webpack_public_path__ + "static/media/Matrix-bg.1efffa27.jpg";